export default __webpack_public_path__ + "static/media/calculator.9d9cc669.svg";